module.exports = __webpack_public_path__ + "img/update_top.f1309e5f.png";